import { Component, Inject, OnInit } from '@angular/core';
import { AttachFileDialogComponent } from '../../../../../../app/modules/document-in-library/attach-file-dialog/attach-file-dialog.component';
import { DocLibraryAttachmentsVM, DocLibraryImplmentsVM } from '../../../entities/global/model';
import { DocumentLibraryService } from '../../../services/document-library.service';
import { DocumentAdjustmentAuditTrailComponent } from './document-adjustment-audit-trail/document-adjustment-audit-trail.component';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-document-library',
  templateUrl: './document-library.component.html',
  styleUrls: ['./document-library.component.scss']
})
export class DocumentLibraryComponent implements OnInit {

  ImplementModelId: number;
  ImplementId: number;
  Title: string = "Asset Document List"
  isGlobal: boolean = false;
  DocumenentList: DocLibraryImplmentsVM[];
  FilePreview: string;
  isLoading:boolean=false;
  constructor(private dialogRef_: MatDialogRef<DocumentLibraryComponent>,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data_: any,
    private _documentLibraryService: DocumentLibraryService) { }

  ngOnInit() {
    this.ImplementModelId = this.data_.ImplementModelId;
    this.ImplementId = this.data_.ImplementId;

    this.LoadAllDocumentLibraryForImplement();
  }

  LoadAllDocumentLibraryForImplement() {
    this.Title = "Asset Document List";
    this.isGlobal = false;
    this.isLoading=true;
    this._documentLibraryService.GetDocumentsForImplement(this.ImplementId).subscribe(res => {
    
      this.DocumenentList = res;
      this.isLoading=false;
    })
  }

  LoadGlobalDocs() {
    this.Title = "Global Document List";
    this.isGlobal = true;
this.isLoading=true;

    this._documentLibraryService.GetGlobleDocuments(this.ImplementId).subscribe(res => {
     
      this.DocumenentList = res;
      this.isLoading=false;

    })
  }

  DocumentCkhChange(docId: number, docInfo: DocLibraryImplmentsVM) {

    var selectdoc = this.DocumenentList.find(x => x.DocId == docId);
    selectdoc.isSelect = !docInfo.isSelect;

    if (docInfo.isSelect == true) {
      this.IncludeAssetDocument(docId, this.ImplementId);
    }
    else {
      this.RemoveAssetDocument(docId, this.ImplementId);
    }

  }

  IncludeAssetDocument(DocId: number, ImplementId: number) {
    this._documentLibraryService.IncludeAssetDocument(DocId, ImplementId).subscribe(res => {
      if (res == true) {
        this.LoadGlobalDocs();
      }
    })
  }

  RemoveAssetDocument(DocId: number, ImplementId: number) {
    this._documentLibraryService.RemoveAssetDocumnet(DocId, ImplementId).subscribe(res => {
      if (res == true) {
        this.LoadAllDocumentLibraryForImplement();
      }
    })
  }

  AddNewAttachment(DocId: number) {
    const dialogRef = this.dialog.open(AttachFileDialogComponent, {
    });
    dialogRef.afterClosed().subscribe(res => {
      
      if (res != false) {
        this.isLoading=true;
        var images_ = (res.FilePreview).split(',');
        this.FilePreview = images_[1];

        var NewFileName= res.NewFileName
        //Update
        let param = new DocLibraryAttachmentsVM();
        param.ImplementId = this.ImplementId;
        param.DocId = DocId;
        param.Attachment = this.FilePreview;
        param.FileName=NewFileName

        this._documentLibraryService.UpdateAssestAttachment(param).subscribe(res => {
          if (res == true) {
            this.LoadAllDocumentLibraryForImplement();
          }
        })

      }

    });
  }
 



  ReplaceAttachment(DocId: number, AttachementInfo: DocLibraryAttachmentsVM) {
    const dialogRef = this.dialog.open(AttachFileDialogComponent, {
    });
    dialogRef.afterClosed().subscribe(res => {
    
      if (res != false) {

        var images_ = (res.FilePreview).split(',');
      this.FilePreview = images_[1];

      var filename= (res.NewFileName)
        //Update
        AttachementInfo.ImplementId = this.ImplementId;
        AttachementInfo.DocId = DocId;
        AttachementInfo.Attachment = this.FilePreview
        AttachementInfo.FileName=filename

        this._documentLibraryService.UpdateAssestAttachment(AttachementInfo).subscribe(res => {
          if (res == true) {
            this.LoadAllDocumentLibraryForImplement();
          }
        })

      }

    });
  }

  ShowUpgrade(docInfo: DocLibraryImplmentsVM) {
    var selectdoc = this.DocumenentList.find(x => x.DocId == docInfo.DocId);
    selectdoc.ShowReplace = !docInfo.ShowReplace;
  }
  onClickDownloadAttachment(attachemetInfo: DocLibraryAttachmentsVM, Doc: DocLibraryImplmentsVM) {
   this.isLoading=true;
if(this.isGlobal==false){
  this._documentLibraryService.LoadSelectedDocumentAttachmentForImplement(attachemetInfo.Id).subscribe(res => {
   // var newstring = res.slice(1);
    //let _newstring = newstring.substring(0, newstring.length - 1);
    var arrBuffer = this.base64ToArrayBuffer(res);
    var blob = new Blob([arrBuffer], { type: 'application/pdf' });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = attachemetInfo.FileName!=null?attachemetInfo.FileName + '.pdf': Doc.DocType + '_Attachment_' + '.pdf';
    link.click();
    this.isLoading=false;
  })
}else{
  this._documentLibraryService.LoadSelectedDocumentAttachmentForGlobal(attachemetInfo.Id).subscribe(res => {
    //var newstring = res.slice(1);
    //let _newstring = newstring.substring(0, newstring.length - 1);
    var arrBuffer = this.base64ToArrayBuffer(res);
    var blob = new Blob([arrBuffer], { type: 'application/pdf' });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download =attachemetInfo.FileName!=null?attachemetInfo.FileName + '.pdf': Doc.DocType + '_Attachment_'  + '.pdf';
    link.click();
    this.isLoading=false;
  })
}
   

  }



  base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  // Audit trail Pop Up
  openDocumentAdjustmentAuditTrailDialog(docId: number) {
    const dialogRef = this.dialog.open(DocumentAdjustmentAuditTrailComponent, {
      panelClass: 'removeModalOverflow',
      disableClose: true,

      data: {
        DocId: docId,
        ImplementId: this.ImplementId,
      }
    });

    dialogRef.afterClosed().subscribe(r => {

    });
  }


  onCloseClick() {
    this.dialogRef_.close();
  }
}
